import React from 'react'
import { formatSalesValue } from '../../utils/formatUtils'

const SixTen = ({ sixTen }) => {
    return (
        <div className='time-stamp space-y-2 p-3'>
            <label className='late'>6PM- 10PM &#8594; <span>{sixTen.pct + "%"}</span></label>
            <div>
                <span className='font-semibold'>Total Sales : </span> {sixTen.total_count} X <span>{formatSalesValue(sixTen.total_sales)}</span>
            </div>
            <div className='numbers space-y-2'>
                <div>
                    <span>Dine-In : </span> {sixTen.dinein_sales === 'None' ? "-" : <>{sixTen.dinein_count} X {formatSalesValue(sixTen.dinein_sales)}</>}
                </div>
                <div>
                    <span>Take-away : </span>{sixTen.tab_sales === 'None' ? "-" : <>{sixTen.tab_count} X {formatSalesValue(sixTen.tab_sales)}</>}
                </div>
            </div>
        </div>
    )
}

export default SixTen